import { Field, Form } from 'react-final-form';
import ConfirmDialog from '../../../components/common/ConfirmDialog';
import styles from './UnderwrtitingDeclaration.module.scss';
import MeritoCheckbox from '../../Finance/components/CustomCheckbox/MeritoCheckbox';
import MeritoButton from '../../../components/common/MeritoButtons/MeritoButtons';

type Props = {
    isOpen: boolean;
    handleClose: () => void;
    handleSubmit: (values: any) => void;
    isSubmitLoading: boolean;
}

const UnderwritingDeclaration = ({ isOpen, handleClose, handleSubmit, isSubmitLoading }: Props) => {


    return (
        <ConfirmDialog
            modalStyles={{ minWidth: 'clamp(300px, 60vw, 860px)' }}
            showButton={false}
            visible={isOpen}
            toggle={() => {
                handleClose();
            }}
            showCloseBtn={false}
            size={"md"}
        >
            <Form
                initialValues={{
                    informationDeclaration: false,
                    informationSharingAuthorization: false,
                    creditAppraisalAuthorization: false,
                }}
                onSubmit={(values) => {
                    handleSubmit(values);
                }}
                render={({ values, handleSubmit, pristine, hasValidationErrors }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <div className={styles.rootContainer}>
                                <div className={styles.topContainer}>
                                    <div className={styles.titleContainer}>
                                        Declaration
                                    </div>
                                    <Field validate={(values) => {
                                        if (values) return ''
                                        else return 'Please confirm'
                                    }} name="informationDeclaration">
                                        {(props) => {
                                            return (
                                                <div className={styles.checkBoxContainer}>
                                                    <MeritoCheckbox

                                                        name={props.input.name}
                                                        value={props.input.value}
                                                        onChange={props.input.onChange}
                                                        showError={false}
                                                        error={props.meta.error}
                                                        touched={props.meta.touched}
                                                    />
                                                    <div className={styles.label}>
                                                        We declare that all information provided by us and existing on this software application is true, and any changes in this information will be duly communicated.
                                                    </div>

                                                </div>
                                            )
                                        }}
                                    </Field>
                                    <Field validate={(values) => {
                                        if (values) return ''
                                        else return 'Please confirm'
                                    }} name="informationSharingAuthorization">
                                        {(props) => {
                                            return (
                                                <div className={styles.checkBoxContainer}>
                                                    <MeritoCheckbox
                                                        name={props.input.name}
                                                        value={props.input.value}
                                                        onChange={props.input.onChange}
                                                        showError={false}
                                                        error={props.meta.error}
                                                        touched={props.meta.touched}
                                                    />
                                                    <div className={styles.label}>
                                                        We authorise Merito ("Jigsaw Financial Technology Pvt Ltd") to securely share information with their lending partners (financial institutions like banks or NBFCs) for the purpose of processing loans on our behalf.
                                                    </div>
                                                </div>
                                            )
                                        }}
                                    </Field>
                                    <Field validate={(values) => {
                                        if (values) return ''
                                        else return 'Please confirm'
                                    }} name="creditAppraisalAuthorization">
                                        {(props) => {
                                            return (
                                                <div className={styles.checkBoxContainer}>
                                                    <MeritoCheckbox
                                                        name={props.input.name}
                                                        value={props.input.value}
                                                        onChange={props.input.onChange}
                                                        showError={false}
                                                        error={props.meta.error}
                                                        touched={props.meta.touched}
                                                    />
                                                    <div className={styles.label}>
                                                        We authorize Merito to process our data for credit appraisal including credit scoring, risk/fraud analysis, due diligence, and financial standing checks, either directly or through third parties (credit bureaus, KYC agencies, vendors, affiliates) in accordance with applicable law and our internal policies.
                                                    </div>
                                                </div>
                                            )
                                        }}
                                    </Field>
                                </div>
                                <div className={styles.bottomContainer}>
                                    <MeritoButton onClick={() => {
                                        handleClose();
                                    }} size="lg" isRounded={true} btnType="button" type="secondary-2" btnText={'Cancel'} />
                                    <MeritoButton loading={isSubmitLoading} disabled={pristine || hasValidationErrors} size="lg" onClick={handleSubmit} isRounded={true} btnType="button" type="primary-1" btnText="Submit" />
                                </div>
                            </div>
                        </form>
                    )
                }}
            />
        </ConfirmDialog>
    );
}

export default UnderwritingDeclaration;